import { render, staticRenderFns } from "./ForwardsMX.vue?vue&type=template&id=2f510d7a&scoped=true"
import script from "./ForwardsMX.vue?vue&type=script&lang=js"
export * from "./ForwardsMX.vue?vue&type=script&lang=js"
import style0 from "./ForwardsMX.vue?vue&type=style&index=0&id=2f510d7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f510d7a",
  null
  
)

export default component.exports